import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChangePasswordPage } from './change-password';
import { ComponentsModule } from '../../app/components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { UserModule } from '../../app/user/user.module';

@NgModule({
  declarations: [
    ChangePasswordPage,
  ],
  imports: [
    IonicPageModule.forChild(ChangePasswordPage),
    TranslateModule.forChild(),
    ComponentsModule,
    UserModule.forRoot()
  ],
})
export class ChangePasswordPageModule {}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.module.ts